export const granularities = ["Daily", "Weekly", "Monthly"];
